import React, { Component, createRef } from 'react';
import { Col, Overlay } from 'react-bootstrap';
import { findDOMNode } from 'react-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
    openCloseTicketSelectionPopUp,
    selectTicketByUser,
    signedOutUserReact
} from '../../../../actions/UserProfileActions';
import cls from 'classnames';
import { TicketSelectionPopover } from './TicketSelectionPopover';
import { NoTicketPopover } from './NoTicketPopover';
import { ticketsSelectionDataSelector } from '../../../../selectors/AgendaSelectors';
const CHOOSE_YOUR_TICKET = 'Choose your ticket';
const YOUR_TICKET = 'Your Ticket';
const NO_TICKETS = 'No Tickets';

class TicketSelect extends Component {


    ticketRef = createRef();
    getTicketNameHolder = () => {
        const { tickets, selectedTicketsIds } = this.props;
        const isDefault = !selectedTicketsIds.length;
        // if user has more than one ticket
        if (tickets.length > 1) {
            // if user has selected a ticket
            if (selectedTicketsIds.length === 1) {
                const selectedTicket = tickets.find(ticket => ticket.id === selectedTicketsIds[0]) || {};
                return selectedTicket.ticketName;
            } else if (selectedTicketsIds.length > 1){
                return `${selectedTicketsIds.length} tickets`;
            } else {
                return CHOOSE_YOUR_TICKET;
            }
        // if use has one ticket
        } else if (tickets.length === 1) {
            return YOUR_TICKET;
        } else if (isDefault) {
            return <span className='padding-right-small padding-left-small'></span>;
        } else {
            return NO_TICKETS;
        }
    }

    render() {
        const {
            tickets,
            me: {
                firstName,
                lastName,
                primaryEmail
            },
            event: {
                name,
                eventId
            },
            ticketSelectionOpen,
            openCloseTicketSelectionPopUp,
            selectTicketByUser,
            selectedTicketsIds,
            sbsShow,
            registrationsUrl,
            signedOutUserReact,
            color1
        } = this.props;
        const classForTicketTile = cls('ticket-select-holder', { open: ticketSelectionOpen });
        const classForTicketSection = cls('select-ticket-section', { 'sbs-show': sbsShow });
        const ticketName = this.getTicketNameHolder();

        if (tickets.length === 1){
            return null;
        }

        return (
            <Col xs={3} sm={3} className={classForTicketSection} ref={this.ticketRef}>
                <div
                    className={classForTicketTile}
                    onClick={openCloseTicketSelectionPopUp}
                >
                    <i className='fa icon-my_tickets-not-selected ticket-holder-icon custom-color color-1' />
                    <span className='ticket-name hidden-xs hidden-sm'>{ticketName || ''}</span>
                    <span className="caret hidden-xs hidden-sm"></span>
                </div>
                <Overlay
                    show={ticketSelectionOpen}
                    placement='bottom'
                    container={this}
                    rootClose={true}
                    onHide={ticketSelectionOpen ? openCloseTicketSelectionPopUp: null}
                    target={() => findDOMNode(this.ticketRef.current)}>
                    {tickets.length
                        ? <TicketSelectionPopover
                            tickets={tickets}
                            userData={{
                                userName: `${firstName} ${lastName}`,
                                primaryEmail
                            }}
                            openCloseTicketSelectionPopUp={openCloseTicketSelectionPopUp}
                            selectedTicketsIds={selectedTicketsIds}
                            selectTicketByUser={selectTicketByUser}
                            eventId={eventId}
                            color1={color1}
                            ticketSelectionOpen={ticketSelectionOpen}/>
                        : <NoTicketPopover
                            openCloseTicketSelectionPopUp={openCloseTicketSelectionPopUp}
                            registrationsUrl={registrationsUrl}
                            signedOutUserReact={signedOutUserReact}
                            userData={{
                                primaryEmail
                            }}
                            ticketSelectionOpen={ticketSelectionOpen}/>
                    }
                </Overlay>
            </Col>
        );
    }
}

const mapDispatchToProps = dispatch => bindActionCreators({
    openCloseTicketSelectionPopUp,
    selectTicketByUser,
    signedOutUserReact
}, dispatch);


export default connect(
    ticketsSelectionDataSelector,
    mapDispatchToProps,
)(TicketSelect);
